import {
  getVendorList as getVendorListAPI,
  addVendor as addVendorAPI,
  getVendor as getVendorAPI,
  addContact as addContactAPI,
  editVendor as editVendorAPI,
  changeVendorStatus as changeVendorStatusAPI,
  getVendorCount as getVendorCountAPI,
  addBulkVendor as addBulkVendorAPI
} from '../api/vendor-management.api'

/**
 * Dispatches vendor list retrieval with optional dropdown flag.
 *
 * @param {string} [type] - Vendor type (e.g. Supplier, sub-contractor).
 * @param {string} [status=''] - Active status filter.
 * @param {boolean|string} [isDropdown] - Whether to return lightweight dropdown attributes.
 * @returns {Function} Redux thunk action.
 */
export const getVendorList = (type, status = '', isDropdown) => {
  return (dispatch, getState) => {
    return getVendorListAPI(type, status, isDropdown)
  }
}

export const getVendor = (id) => {
  return (dispatch, getState) => {
    return getVendorAPI(id)
  }
}

export const addVendor = (data) => {
  return (dispatch, getState) => {
    return addVendorAPI(data)
  }
}

export const addContact = (data, id) => {
  return (dispatch, getState) => {
    return addContactAPI(data, id)
  }
}

export const editVendor = (data, id) => {
  return (dispatch, getState) => {
    return editVendorAPI(data, id)
  }
}

export const changeVendorStatus = (id) => {
  return (dispatch, getState) => {
    return changeVendorStatusAPI(id)
  }
}

export const getVendorCount = () => {
  return (dispatch, getState) => {
    return getVendorCountAPI()
  }
}

export const addBulkVendor = ({ vendorList = [] }) => {
  return (dispatch, getState) => {
    return addBulkVendorAPI({ vendorList })
  }
}
